(function () {
  if (window.__ozTradeScroll) return;
  window.__ozTradeScroll = true;

  document.addEventListener(
    "click",
    function (event) {
      var link = event.target.closest && event.target.closest("a[href]");
      if (!link) return;

      var raw = link.getAttribute("href") || "";
      if (raw !== "#oz-trade-application" && raw.slice(-21) !== "#oz-trade-application") return;

      var target = document.getElementById("oz-trade-application");
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      var header = document.getElementById("header");
      var offset = header ? Math.round(header.getBoundingClientRect().bottom) + 16 : 96;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", "#oz-trade-application");
      }
    },
    true
  );
})();
